import { Address, CountryCode } from "../types";

export const getCountryName = (address?: Address) => {
  switch (address?.countryCode) {
    case CountryCode.Canada:
      return "Canada";
    case CountryCode.USA:
      return "USA";
    default:
      return address?.otherCountry;
  }
};

export const getLocationCode = (address?: Address) => {
  switch (address?.countryCode) {
    case CountryCode.Canada:
      return address?.provinceCode;
    case CountryCode.USA:
      return address?.stateCode;
    default:
      return "";
  }
};

export const getFirstAddressLine = (address?: Address) =>
  [address?.addressLine1, address?.addressLine2, address?.city]
    .filter(Boolean)
    .join(", ");

export const getSecondAddressLine = (address?: Address) => {
  const location = [getLocationCode(address), address?.postalOrZip]
    .filter(Boolean)
    .join(" ");

  return [location, getCountryName(address)].filter(Boolean).join(", ");
};

export const getFullAddress = (address?: Address) =>
  [getFirstAddressLine(address), getSecondAddressLine(address)]
    .filter(Boolean)
    .join(", ");
